module.exports = __webpack_public_path__ + "media/images/icon-close-search-b81aeb39cb5bc8bf73127379c65c4a4b.svg";